import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import Dropdown from 'jd-library/Dropdown';
import InputWithMovingLabel from "jd-library/InputWithMovingLabel";
import { handleOnDropdownChange, handleOnChange, handleOnBlur } from '../../customActions';
import styles from './styles.scss';
import InputWithAutosuggestSlider from '../textboxAutosuggestContainer/InputWithAutosuggestSlider';
import axios from "axios";
import { updateSpecificationData } from '../../../../../actions/productSpecification';

function DropdownContainer(props){
    const [dropdownOptions, setDropdownOptions] = useState([]);
    const [frameArr, setFrameArr] = useState([])
    const [autoSuggestSlider, setAutoSuggestSlider] = useState(false)
    const [hasOtherOption,updateOtherOption] = useState(false)
    const [textboxValueKey,updateTextboxValueKey] = useState('textboxValue')
    const {
        item = {},
        handleOnDropdownChange,
        parentIndex,
        handleOnChange,
        handleOnBlur,
        isSellOnline,
        isAutoSuggest
    } = props;

    let {
        s_id,
        s_type,
        s_type_options,
        s_nm,
        userInput,
        s_mandatory,
        s_re_mandatory,
        s_dnm,
        textBoxIsHidden = false,
        isDependentTextBox
    } = item;

    useEffect(() => {
        let foundOtherOption = false;
        const options = s_type_options.map((d_item, d_index) => {
            if(d_item.toLowerCase().includes('other')) {
                updateOtherOption(d_item);
                item.userInput.value && !item.userInput.textboxValue && updateTextboxValueKey('value')
                foundOtherOption = d_item;
            }
            return {
                key: d_item,
                label: d_item
            }
        });
        setDropdownOptions(options);
        if(item.userInput.value && !item.userInput.textboxValue) {
            let foundInList = false;
            options.map(cur => {
                if(cur.key == item.userInput.value) {
                    foundInList = true;
                }
            })
            if(!foundInList && (s_type_options.includes('Others') || s_type_options.includes('Other')) ) {
                item.userInput.textboxValue = item.userInput.value;
                item.userInput.value = s_type_options.includes('Others') ? 'Others': 'Other';
                item.textBoxIsHidden = true;
                let editablePuvSpecAttributes = props.productSpecification.editablePuvSpecAttributes;
                editablePuvSpecAttributes[props.parentIndex] = item; 
                props.updateSpecificationData({...props.productSpecification,editablePuvSpecAttributes})
                foundOtherOption && updateTextboxValueKey('textboxValue')
            }
        }
        let catId = props.editProduct.psv_node_id ? props.editProduct.psv_node_id : props.editProduct.leafId;
        axios
            .get(
                `/vendorapis/products/product/getSpecList?supplierId=${props.supplierId}&catid=${catId}&sid=${s_id}`
            )
            .then((res) => {
                let result = [];
                if (res.data.results?.slist?.length) {
                    result = res.data.results.slist[0][s_id]?.split("|~|");
                }
                if(foundOtherOption) {
                    result = [...new Set([...s_type_options.filter(cur => cur != foundOtherOption),...result])];
                }
                setFrameArr([...result]);
            });
        s_type_options.some(option => {
            if (userInput?.value && userInput.value.toLowerCase()==option.toLowerCase()) {
                userInput.value = option;
                return true;
            }
        });    
    }, []);
    let inputComponentOptions = {};
    if(isDependentTextBox ){
        let errorName = hasOtherOption ? (userInput['error'] ? 'error' : 'textboxError') : 'textboxError';
        inputComponentOptions = {
            label: `${hasOtherOption ? '' :'Other'} ${s_dnm}` || "",
            holderClass: styles["dependent-text-field"],
            input:{
                value: userInput[textboxValueKey] || '',
                type: 'text',
                name: s_nm,
                autoFocus: userInput[textboxValueKey] || isAutoSuggest ? false : true,
                onChange: (e) => handleOnChange({e, parentIndex, item, key: "textboxValue",isSellOnline}),
                onBlur: (e) => !isAutoSuggest && handleOnBlur({e, parentIndex, item, key: errorName, isDependentTextBox : true}),
                readOnly: ((props?.isEnrichSpec && userInput[textboxValueKey]) || isAutoSuggest) ? true : false,
            },
            errorMessage: userInput[errorName],
            infoMessage:!userInput[errorName] && (props.showSellOnline || props.isService ? s_mandatory =='1' : s_re_mandatory == '1') && !props.isAuditor  && !props.session.viaOmni ? 'Required Field':''
        }
    }

    return (
        <div className={styles["dropdown-container"]}>
            <div className={styles["dropdown-div"]}>
                {!hasOtherOption ? 
                    <>
                        <Dropdown
                            key={`${s_type}-${s_id}`}
                            className={styles["dropdown-div-input"]}
                            activeClass={styles["dropdown-div-input-active"]}
                            valueClass={'dropdown-div-input-value-class'}
                            label={userInput?.value && s_dnm || ""}
                            optionList={dropdownOptions}
                            onChange={(e, selectedIndex) => {
                                                            e.label.toLowerCase() == 'others' && isAutoSuggest && setAutoSuggestSlider(true)
                                                            handleOnDropdownChange({value: e.label || "", parentIndex, item});}}
                            placeholder={s_dnm}
                            value={userInput?.value}
                            error={userInput?.error}
                            disabled={props?.isEnrichSpec && userInput?.value ? true : false}
                        />
                        {(props.showSellOnline || props.isService ? s_mandatory =='1' : s_re_mandatory == '1') && !props.isAuditor && !props.session.viaOmni ?
                            <div className={`${!userInput?.error ? 'drop-error-required' : 'drop-error-required-red'}`}>
                                <span>{userInput?.error || 'Required Field'}</span>
                            </div>
                            : 
                            null
                        }
                    </>
                :null}
            </div>
            {textBoxIsHidden || hasOtherOption?  (
                <div className={`${styles['dependent-textbox-container']} ${hasOtherOption ? styles['other-val']:''}`}>
                    {isAutoSuggest ? 
                        <InputWithAutosuggestSlider sliderHeading={s_dnm} suggestions={frameArr.map((item, index) => { return { key: index, value: item } })}
                            {...inputComponentOptions} defaultOpen={autoSuggestSlider}
                            onRightIconClick={() => {}}
                            onSelect={res => {
                                setAutoSuggestSlider(false)
                                let txtboxKey = 'textboxValue';
                                if(hasOtherOption) {
                                    if(res.type == 'customValue') {
                                        txtboxKey = 'textboxValue';
                                        textboxValueKey != 'textboxValue' && updateTextboxValueKey('textboxValue');
                                        handleOnChange({ e: { target: { value: res.value } }, parentIndex,item: {...item,userInput: {...item.userInput,value: hasOtherOption}}, key: "textboxValue", isSellOnline })
                                    }else {
                                        txtboxKey = 'value';
                                        updateTextboxValueKey('value');
                                        handleOnChange({ e: { target: { value: res.value } }, parentIndex,item: {...item,userInput: {...item.userInput,textboxValue: ''}}, key: "value", isSellOnline })
                                    }
                                    return;
                                }
                                handleOnChange({ e: { target: { value: res.value } }, parentIndex, item, key: txtboxKey, isSellOnline })
                            }}
                            ignoreCross={true}
                            fromBrand={true}
                        /> : <InputWithMovingLabel {...inputComponentOptions} />
                    }
                </div>) : null
            }
        </div>
    )
}

const mapStateToProps = (state, props) => {
    return {
        ...props,
        item: state.productSpecification.editablePuvSpecAttributes[props.parentIndex],
        productSpecification: state.productSpecification,
        isSellOnline: state.products.editProduct.isSellOnline || props.showSellOnline,
        supplierId : state.session.supplierId,
        editProduct : state.products.editProduct,
        session: state.session,
        isService: state.products.editProduct.categoryType == 'service',
        isAuditor: state.session?.user?.loggedUser?.userType == "AUDITOR"
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        handleOnChange: (payload) => dispatch(handleOnChange(payload)),
        handleOnDropdownChange: (payload) => handleOnDropdownChange(payload, dispatch),
        handleOnBlur: (payload) => dispatch(handleOnBlur(payload)),
        updateSpecificationData: (payload) => updateSpecificationData(payload)
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(DropdownContainer)